<template>
  <div class="login-page">
    <van-nav-bar title="登录/注册" fixed />
    <div class="form-container">
      <van-tabs v-model="activeTab">
        <van-tab title="登录">
          <van-form @submit="onLogin">
            <van-field v-model="loginForm.username" label="用户名" placeholder="请输入用户名" required />
            <van-field v-model="loginForm.password" label="密码" type="password" placeholder="请输入密码" required />
            <div style="margin: 16px 0;">
              <van-button round block type="primary" native-type="submit">登录</van-button>
            </div>
          </van-form>
        </van-tab>
        <van-tab title="注册">
          <van-form @submit="onRegister">
            <van-field v-model="registerForm.username" label="用户名" placeholder="请输入用户名" required />
            <van-field v-model="registerForm.password" label="密码" type="password" placeholder="请输入密码" required />
            <van-field v-model="registerForm.confirmPassword" label="确认密码" type="password" placeholder="请再次输入密码" required />
            <div style="margin: 16px 0;">
              <van-button round block type="primary" native-type="submit">注册</van-button>
            </div>
          </van-form>
        </van-tab>
      </van-tabs>
    </div>
	<div style="padding: 40px 0;"><a href="https://beian.miit.gov.cn/">琼ICP备2025057209号-1</a></div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      activeTab: 0,
      loginForm: {
        username: '',
        password: ''
      },
      registerForm: {
        username: '',
        password: '',
        confirmPassword: ''
      }
    }
  },
  methods: {
    onLogin() {
      const storedUsers = JSON.parse(localStorage.getItem('users') || '[]')
      const user = storedUsers.find(u => u.username === this.loginForm.username && u.password === this.loginForm.password)
      if (user) {
        localStorage.setItem('currentUser', JSON.stringify(user))
        this.$toast.success('登录成功')
        this.$router.push('/profile')
      } else {
        this.$toast.fail('用户名或密码错误')
      }
    },
    onRegister() {
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.$toast.fail('两次输入的密码不一致')
        return
      }
      const storedUsers = JSON.parse(localStorage.getItem('users') || '[]')
      if (storedUsers.some(u => u.username === this.registerForm.username)) {
        this.$toast.fail('用户名已存在')
        return
      }
      storedUsers.push({
        username: this.registerForm.username,
        password: this.registerForm.password
      })
      localStorage.setItem('users', JSON.stringify(storedUsers))
      this.$toast.success('注册成功')
      this.activeTab = 0
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #f7f8fa;
  padding-top: 46px;
}
.form-container {
  margin: 40px 16px 0 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  padding: 24px 16px 16px 16px;
}
</style> 